import http from "./httpServices";

/**
 * Transcript / AI Notetaker Service
 * REST API calls for transcript and meeting notes retrieval
 */

/**
 * Get the full transcript for a meeting session (S3-based)
 */
export const getTranscriptBySession = async (meetingId, sessionId) => {
  return http.get(`/transcript/${meetingId}/${sessionId}`);
};

/**
 * Get transcript by recording ID (MongoDB-based)
 */
export const getTranscript = async (recordingId) => {
  return http.get(`/recording/${recordingId}/transcript`);
};

/**
 * Get a presigned download URL for the raw transcript file
 */
export const getTranscriptDownloadUrl = async (meetingId, sessionId) => {
  return http.get(`/transcript/${meetingId}/${sessionId}/download`);
};

/**
 * Get structured meeting notes for a session
 */
export const getMeetingNotes = async (meetingId, sessionId) => {
  return http.get(`/transcript/${meetingId}/${sessionId}/notes`);
};

/**
 * Manually trigger notes generation from an existing transcript
 */
export const generateMeetingNotes = async (meetingId, sessionId, hostName, meetingTitle) => {
  return http.post(`/transcript/${meetingId}/${sessionId}/generate-notes`, {
    hostName,
    meetingTitle,
  });
};

export default {
  getTranscript,
  getTranscriptDownloadUrl,
  getMeetingNotes,
  generateMeetingNotes,
};
